<template>
<div class="back">
  <div class="dialogbox" :style="{
    width: `${width}px`,
    maxHeight: height ? `${height}px` : 'fit-content',
    minHeight: '700px'
  }">
  <div class="headerBox">
    <span>日期: {{date}}</span>
    <span :style="{marginLeft: 'auto', display: 'flex', gap: '8px', marginRight: '30px'}">
      <button class="detailBtn" @click="$emit('detail')">銷項詳情</button>
      <button v-if="showPrint" class="printBtn" @click="$emit('print')"></button>
    </span>
    <button class="closeBtn" @click="$emit('close')"><iconClose :width="25" :height="25" color="#FFFFFF" backgroundColor="none"/></button>
  </div>
  <div>
    <slot/>
  </div>
  </div>
</div>
</template>

<script>
import iconClose from '../SVG/iconClose'
export default {
  name: 'dialogbox',
  props: ['show', 'width', 'label', 'height', 'date', 'id', 'leader', 'showPrint'],
  components: {
    iconClose
  }

}
</script>

<style lang="scss">
.dialogbox > div:not(.headerBox) > div:not(.editBox) {
    height: auto;
    display: grid;
    gap: 20px;
}
</style>
<style lang="scss" scoped>
.detailBtn {
  border: none;
  width: 120px;
  height: 35px;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  gap: 6px;
  &::before {
    content: '';
    display: inline-flex;
    width: 20px;
    height: 20px;
    mask-image: url(./detail.svg);
    background-color: var(--color-checked);
    mask-repeat: no-repeat;
  }
}
.printBtn {
  border: none;
  width: 45px;
  height: 35px;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  gap: 6px;
  &::before {
    content: '';
    display: inline-flex;
    width: 25px;
    height: 22px;
    mask-image: url(./print.svg);
    background-color: var(--color-checked);
    mask-repeat: no-repeat;
  }
}
.back {
  position: absolute;
  top: -90px;
  bottom: 0;
  left: 1151px;
  right: 0;
  mix-blend-mode: normal;
  backdrop-filter: blur(8px);
  background: rgba(94, 94, 94, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.headerBox {
  width: 100%;
  height: 65px;
  background-color: var(--color-pri);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 27px;
  box-sizing: border-box;
  position: relative;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 35px;
  letter-spacing: 0.1em;
  border-radius: 10px 10px 0 0;
  color: #FFFFFF;
  gap: 35px;
}
.closeBtn {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: transparent;
  border: none;
  z-index: 91;
  width: 25px;
  height: 25px;
}
.dialogbox {
  border-radius: 10px;
  &::before {
    display: none!important;
  }
  padding: 0!important;
  margin: 0!important;
  height: fit-content;
  min-width: 481px;
  position: relative;
  background-color: #FFFFFF;
  z-index: 90;
  box-shadow: -4px 0px 15px rgba(0, 0, 0, 0.25);
  &>div:not(.headerBox) {
    border-radius: 10px;
    margin: 0!important;
    position: relative;
    width: 100%;
    height: calc(100% - 110px);
    background-color: #FFFFFF;
    display: block;
    flex-direction: column;
    gap: 20px;
    &>div {
      background-color: #FFFFFF;
      height: auto;
      display: grid;
      margin-block: 40px;
      margin-inline: 20px;
      padding-inline: 20px;
    }
  }
}
</style>
